<template>
  <div id="app">
    <Navbar :game-slug="gameSlug" :game-settings="gameSettings"></Navbar>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view :game-slug="gameSlug" :game-settings="gameSettings" />
    <Bottom></Bottom>
    <div v-if="gameSlug" class="modal" id="createGameModal" tabindex="-1" role="dialog" aria-labelledby="createGameModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create a game</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6 col-lg-4">
                <!-- <div class="form-group">
                  <label class="mb-0" for="inc">Variant</label>
                  <select name="inc" id="inc" class="form-control form-control-sm" v-model="gameSettings.board">
                    <option v-for="b in boards" :value="b.key" v-bind:key="b.key">{{ b.name }}</option>
                  </select>
                </div> -->
                <div class="form-group">
                  <label class="mb-0" for="min">Minutes</label>
                  <select name="min" id="min" class="form-control" v-model="gameSettings.min">
                    <option value="1">1 minutes</option>
                    <option value="2">2 minutes</option>
                    <option value="3">3 minutes</option>
                    <option value="4">4 minutes</option>
                    <option value="5">5 minutes</option>
                    <option value="6">6 minutes</option>
                    <option value="7">7 minutes</option>
                    <option value="8">8 minutes</option>
                    <option value="9">9 minutes</option>
                    <option value="10">10 minutes</option>
                    <option value="15">15 minutes</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label class="mb-0" for="inc">Increments</label>
                  <select name="inc" id="inc" class="form-control" v-model="gameSettings.inc">
                    <option value="0">None</option>
                    <option value="1">1 seconds</option>
                    <option value="2">2 seconds</option>
                    <option value="3">3 seconds</option>
                    <option value="4">4 seconds</option>
                    <option value="5">5 seconds</option>
                    <option value="6">6 seconds</option>
                    <option value="7">7 seconds</option>
                    <option value="8">8 seconds</option>
                    <option value="9">9 seconds</option>
                    <option value="10">10 seconds</option>
                    <option value="15">15 seconds</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label class="mb-0" for="inc">Board</label>
                  <select name="inc" id="inc" class="form-control" v-model="gameSettings.config.board">
                    <option v-for="b in boards" :value="b.key" v-bind:key="b.key">{{ b.name }}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="col-lg-6">
                <div class="form-group">
                  <label class="mb-0" for="inc">Rule set</label>
                  <select name="inc" id="inc" class="form-control" v-model="gameSettings.rules" disabled>
                    <option value="copenhagen">Default (Copenhagen)</option>
                  </select>
                </div>
              </div> -->
              <div class="col-lg-12 text-center" v-if="getUserData">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label class="btn btn-outline-dark" :class="{ 'active': gameSettings.mode === m }" @click.prevent="gameSettings.mode = m" v-for="m in ['rated', 'casual']" v-bind:key="m">
                    <input type="radio" name="gameType_modal" :id="m" autocomplete="off" :checked="gameSettings.mode === m"> {{ m | cap }}
                  </label>
                </div>
              </div>
              <div class="col-lg-12 text-center bg-dark text-light py-2 mt-3 lead" v-if="getUserData">
                <span class="fad" :class="types[gameSettings.type].icon"></span> {{ gameSettings.type | cap }} {{ getRating() | floor }}
              </div>
              <div class="col-lg-12 text-center py-2 mt-3">
                <h4 class="font-weight-bold m-0">Choose a side</h4>
              </div>
              <div class="col-lg-12 text-center">
                <label class="btn btn-outline-dark p-2 mt-3" :class="{ 'mr-3': s !== 'd', 'p-3': s === 'r' }" @click.prevent="createGameWithSide(s)" v-for="s in Object.keys(sideNames[gameSlug])" v-bind:key="s">
                  <img style="width: 30px;" :src="`/img/${gameSlug}_${sideNames[gameSlug][s]}.png`" :alt="sideNames[gameSlug][s]" class="mt-1 mb-1"> <div>{{ sideNames[gameSlug][s] | cap }}</div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import config from '@/config';
import Navbar from '@/components/Navbar.vue';
import Bottom from '@/components/Bottom.vue';

const $ = window.jQuery;

export default {
  name: 'app',
  components: {
    Navbar,
    Bottom,
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'isAnonymous', 'getCurrentUser', 'getDefaultUsername', 'getUserData']),
  },
  watch: {
    $route: {
      handler() {
        window.$('[data-toggle="tooltip"]').tooltip('hide');
        this.setGameSlug();
      },
    },
    'gameSettings.min': {
      handler() {
        this.onTimeChange();
      },
    },
    'gameSettings.inc': {
      handler() {
        this.onTimeChange();
      },
    },
    'gameSettings.mode': {
      handler() {
        this.saveGameMode();
      },
    },
  },
  mounted() {
    $('#createGameModal').on('hidden.bs.modal', () => {
      this.gameSettings.lobby = true;
    });

    this.$root.$on('createGame', (obj, cb) => {
      this.createGame(obj, (doc) => cb(doc));
    });

    this.$root.$on('showCreateGameModal', (obj) => {
      this.showCreateGameModal(obj);
    });
  },
  created() {
    $('body').css({ paddingTop: (this.topbar) ? '88px' : '56px' });
    this.setGameSlug();
    this.$root.$on('setGameSlug', this.setGameSlug);
    if (this.$localStorage.get('gameMode')) {
      this.gameSettings.mode = this.$localStorage.get('gameMode');
    }
  },
  methods: {
    showCreateGameModal(obj) {
      if (typeof obj !== 'undefined' && typeof obj.lobby !== 'undefined') {
        this.gameSettings.lobby = obj.lobby;
      }
      $('#createGameModal').modal();
    },
    createGameWithSide(side) {
      this.createGame({ side }, (doc) => this.$router.push(`/create_game/${doc.id}`));
    },
    createGame(obj, cb) {
      this.gameSettings.game = this.gameSlug;
      if (typeof obj.game !== 'undefined') {
        this.gameSettings.game = obj.game;
      }

      let { side } = obj;
      if (typeof side === 'undefined' || side === 'r') {
        const sides = _.without(Object.keys(this.sideNames[this.gameSettings.game]), 'r');
        side = sides[Math.floor(Math.random() * 2)];
      }

      if (typeof obj.min !== 'undefined') {
        this.gameSettings.min = obj.min;
      }

      if (typeof obj.inc !== 'undefined') {
        this.gameSettings.inc = obj.inc;
      }

      if (typeof obj.type !== 'undefined') {
        this.gameSettings.type = obj.type;
      }

      if (typeof obj.config !== 'undefined') {
        this.gameSettings.config = obj.config;
      }

      if (this.getCurrentUser && this.getCurrentUser.isAnonymous) {
        this.gameSettings.mode = 'casual';
      }

      if (typeof obj.mode !== 'undefined') {
        this.gameSettings.mode = obj.mode;
      }

      // lobby will be true when modal is hidden, so cache its value
      let theLobby = this.gameSettings.lobby;

      if (typeof obj.lobby !== 'undefined') {
        theLobby = obj.lobby;
      }

      $('#createGameModal').modal('hide');

      const db = window.firebase.firestore();
      const user = this.getCurrentUser;
      const userData = this.getUserData;

      let username = this.getDefaultUsername;
      if (userData && userData.username) {
        ({ username } = userData);
      }

      const players = [
        {
          uid: user.uid,
          username,
          rating: this.getRating(),
        },
      ];

      const playerInfo = [
        {
          side,
          player: user.uid,
          captures: 0,
        },
      ];

      this.gameSettings.config.playerInfo = playerInfo;

      db.collection('games').add({
        ...this.gameSettings,
        players,
        createdAt: Date.now(),
        lobby: theLobby,
        playerCount: 1,
      }).then((doc) => cb(doc));
    },
    getRating() {
      const userData = this.getUserData;
      if (this.getCurrentUser && this.getCurrentUser.isAnonymous) {
        return 0;
      }

      if (userData && userData.ratings && userData.ratings[this.gameSettings.game] && userData.ratings[this.gameSettings.game][this.gameSettings.type]) {
        return userData.ratings[this.gameSettings.game][this.gameSettings.type].rating;
      }

      return 1500;
    },
    saveGameMode() {
      this.$localStorage.set('gameMode', this.gameSettings.mode);
    },
    onTimeChange() {
      const gameLengthInMinutes = (this.gameSettings.min * 60 + this.gameSettings.inc * 40) / 60;

      this.gameSettings.type = 'bullet';
      if (gameLengthInMinutes >= 3) {
        this.gameSettings.type = 'blitz';
      }

      if (gameLengthInMinutes >= 8) {
        this.gameSettings.type = 'rapid';
      }
      if (gameLengthInMinutes >= 25) {
        this.gameSettings.type = 'classical';
      }
    },
    setGameSlug(slug) {
      if (this.games.indexOf(this.$route.name) > -1) {
        this.gameSlug = this.$route.name;
      } else if (this.$localStorage.get('gameSlug')) {
        this.gameSlug = this.$localStorage.get('gameSlug');
      } else if (this.$route.params && this.$route.params.game_slug) {
        this.gameSlug = this.$route.params.game_slug;
      } else if (slug) {
        this.gameSlug = slug;
      }
      this.$localStorage.set('gameSlug', this.gameSlug);
    },
  },
  data() {
    return {
      gameSlug: '',
      games: config.games,
      topbar: config.topbar,
      appName: config.appName,
      sideNames: config.sideNames,
      types: config.types,
      boards: [
        { key: '11_classic', name: 'Hnefatafl (Classic 11x11)' },
        { key: '11_line', name: 'Cross 11x11' },
        { key: '11_lewiss', name: 'Lewiss Cross 11x11' },
        { key: '11_tawlbwrdd', name: 'Tawlbwrdd (Welsh 11x11)' },
        { key: '9_tablut', name: 'Tablut (Saami 9x9)' },
        // { key: '7_brandubh', name: 'Brandubh (Irish 7x7)' },
        // { key: '13_parlett', name: 'Parlett 13x13' },
        // { key: '15_damienwalker', name: 'Damien Walker 15x15' },
      ],
      gameSettings: {
        config: {
          board: '11_classic',
          rules: 'copenhagen',
        },
        min: 3,
        inc: 2,
        mode: 'rated',
        type: 'blitz',
        lobby: true,
      },
    };
  },
};

</script>


<style lang="scss">
body {
  position: relative;
  overflow-x: hidden;
  background: #f0f0f0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
h1, h2, h3, h4, h5, h6 {
  letter-spacing: -0.02em;
}
.btn {
  font-weight: 500;
  letter-spacing: -0.03em;
  // font-weight: bold;
}
.text-no-decoration {
  &, &:hover, &:focus {
    text-decoration: none;
  }
}
.bg-discord {
    $discord: #7289DA;
    background: $discord;
    &:hover {
      background: darken($discord, 10%);
    }
  }
.bg-discord-dark {
  $discord: #7289DA;
  background: darken($discord, 10%) !important;

  &:hover {
    background: darken($discord, 30%) !important;
    &.text-light {
      color: #fff !important;
    }
  }
}
.table td, .table th {
  border-top: 0 ;
}
.text-insignificant {
  color: rgba(0,0,0,0.3);
}
.text-light-insignificant {
  color: rgba(255,255,255,0.7);
}
.card--selectable {
  border: none;
  cursor: pointer;
  transition: 0.3s all;
  border: 1px solid transparent;
}
.card--selectable:hover {
  border: 1px solid #333;
  text-decoration: none;
}
.nav-link {
  padding: .4rem 1rem !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
